import { useSelector } from "react-redux";
import { RootState } from "store/store";

export function useShowExternalControlsText() {
  return useSelector((st: RootState) => !st.localState.isAirportMarkerOpen);
}
